<div class="container" [class.mobile]="isMobile">
  <div class="main-title">
    {{'Adresses utiles' | translate}}
  </div>
  <div *ngIf="addresses1" class="description" [innerHTML]="addresses1.text"
    (click)="updateText(addresses1, updateTextTemplate)">
  </div>
  <ng-container *ngIf="this.translate.currentLang === 'fr'">
    <iframe allow="geolocation" width="100%" height="500px" frameborder="0" allowfullscreen
      src="https://umap.openstreetmap.fr/fr/map/adresses-utiles_317407?scaleControl=true&miniMap=false&scrollWheelZoom=false&zoomControl=true&allowEdit=false&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=true&onLoadPanel=undefined&captionBar=false&fullscreenControl=true&measureControl=false&editinosmControl=false">
    </iframe>
  </ng-container>
  <ng-container *ngIf="this.translate.currentLang === 'en'">
    <iframe allow="geolocation" width="100%" height="500px" frameborder="0" allowfullscreen
      src="https://umap.openstreetmap.fr/fr/map/useful-addresses_317421?scaleControl=true&miniMap=false&scrollWheelZoom=false&zoomControl=true&allowEdit=false&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=true&onLoadPanel=undefined&captionBar=false&fullscreenControl=true&locateControl=null&measureControl=false&editinosmControl=false"></iframe>
  </ng-container>
</div>

<ng-template #updateTextTemplate>
  <div class="modal-content">
    <div class="header">
      Update text
      <div class="close" (click)="modalRef.hide()">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div class="content">
      <textarea rows="25" [(ngModel)]="textModel.text"></textarea>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveText()">Save</button>
      <button class="wire-btn default" (click)="modalRef.hide()">Cancel</button>
    </div>
  </div>
</ng-template>